import React from "react"
//import { Link } from "gatsby"
import {graphql, StaticQuery, Link} from 'gatsby'
import './Teams.css';

const Teams = () => (
    <StaticQuery query={graphql`
      {
        allWordpressWpTeam {
          edges {
            node {
              title
              excerpt
              content
              featured_media {
                source_url
              }
              slug
            }
          }
        }
      }
    `} render={props => (
      
      <div className="row no-gutters">
        {props.allWordpressWpTeam.edges.map(post => (
          <div className="col-md-4" key={post.node.id}>
            <div className="team-cover z-depth-1 view zoom">
              <Link to={`/lag/${post.node.slug}`}><img src={post.node.featured_media.source_url} alt="Lagbilde" className="img-fluid team-cover" /></Link>
                <h1 className="team-title font-weight-bold h1-responsive"><Link to={`/lag/${post.node.slug}`}>{post.node.title}</Link></h1>
            </div>
          </div>
        ))}
      </div>
      

    )} />
)

export default Teams;